import { render, staticRenderFns } from "./RankingList.vue?vue&type=template&id=f98f54d2&scoped=true&"
import script from "./RankingList.vue?vue&type=script&lang=js&"
export * from "./RankingList.vue?vue&type=script&lang=js&"
import style0 from "./RankingList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingList.vue?vue&type=style&index=1&id=f98f54d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f54d2",
  null
  
)

export default component.exports